<template>
    <div>
        <ul id="popup_product_tree" class="b-products-tree__list tree">
            <li class="branch" v-for="(brand, index ) in brands" :key="index">
                <i
                        @click="showBrand(index)"
                        :class="isActive(index) ?
                         'indicator glyphicon glyphicon-minus-sign' :
                          'indicator glyphicon glyphicon-plus-sign'"
                ></i>
                <a @click="showBrand(index)"
                   href="#">{{brand.title}}</a>
                <select-brand
                        :brand="brand"
                        :isOpen="isActive(index)"
                        :translations="translations"
                ></select-brand>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: ['translations'],
        data() {
            return {
                toShowLoader: true,
                brands: [],
                activeIndex: null,
            };
        },
        mounted() {
            this.getBrands();
        },
        methods: {
            getBrands() {
                this.$http.get('/catalog/products/get_tree_brands')
                    .then(function (response) {
                        this.brands = response.data;
                    });
            },
            showBrand(brandId) {
                if (this.activeIndex == brandId) {
                    this.activeIndex = null;
                    return;
                }
                this.activeIndex = brandId;
            },
            isActive(index) {
                return this.activeIndex == index;
            }
        }
    };
</script>
